/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

SEO Accordion

*/

import initSEOAccordion from 'allink-core-static/js/modules/seo-accordion';

$(() => {
    const options = {
        duration: 400,
    };

    // on page load
    initSEOAccordion(options);

    // on cms content refresh
    if (window.CMS) {
        CMS.$(window).on('cms-content-refresh', () => {
            initSEOAccordion(options);
        });
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/seo-accordion.js